module.exports = __webpack_public_path__ + "img/pro-two.5c94c9fb.png";